import React, { useEffect, useState } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Space,
  Table,
  Tooltip,
  DatePicker,
  Tag,
  Flex,
  Row,
  Form,
  Select,
  Drawer,
  Col,
  Badge,
  Switch,
  notification,
  InputNumber,
  Typography,
  message,
} from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useAtom } from "jotai";
import { studentList, studyLevelState } from "../states/student";
import { userRole, userStudentCityAccess } from "../states/userRole";
import { citysList } from "../states/citys";
import Autocomplete from "react-google-autocomplete";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../axios.js";
import {
  DATE_FILTER_TYPE,
  DATE_RANGE_MAP,
  getDateRange,
  STUDENT_DEALINGS_PRIORITY_LEVEL_COLORS,
  STUDENT_DEALINGS_STATUS_COLORS,
} from "../components/constants";
import { USER_ROLES } from "../constants/roleConstants.js";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = "Asia/Kolkata";

const { RangePicker } = DatePicker;
const { Search } = Input;
const { Option } = Select;
const apiKey = (window._env_ && window._env_.REACT_APP_GOOGLE_MAPS_API_KEY) || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const dateRangeMap = {
  today: {
    fromDate: dayjs().startOf("day").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("day").format("YYYY-MM-DD"),
  },
  yesterday: {
    fromDate: dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "day").endOf("day").format("YYYY-MM-DD"),
  },
  this_week: {
    fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
  },
  last_week: {
    fromDate: dayjs().subtract(1, "week").startOf("week").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "week").endOf("week").format("YYYY-MM-DD"),
  },
  this_month: {
    fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  },
  last_month: {
    fromDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
  },
};

/* eslint-disable no-unused-vars */
const Student = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();

  const [searchText, setSearchText] = useState();
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [searchFieldType, setSearchFieldType] = useState("first_name");
  const [filterForm] = Form.useForm();
  const [geoSearchData, setGeoSearchData] = useState(null);
  const [filtersCount, setFiltersCount] = useState(0);
  const [citys, _setCitys] = useAtom(citysList);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useAtom(studentList);
  const [open, setOpen] = useState(false);
  const [role, _setRole] = useAtom(userRole);
  const [toggle, _setToggle] = useState(false); // unreachable code
  const [studentCityAccess, _setStudentCityAccess] = useAtom(userStudentCityAccess);
  const [activeRowId, setActiveRowId] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
    hasNextPage: false,
  });

  const [globalFilter, setGlobalFilter] = useState(null);
  const [dateRangeType, setDateRangeType] = useState("relative");
  const [isCreatedAt, setIsCreatedAt] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [presetRange, setPresetRange] = useState("");
  const [limit, setLimit] = useState(25);
  const [dataHandle, setDataHandle] = useState(0); // To re-fetch on update data
  const [courseCategory, setCourseCategory] = useState([]);

  const [studyLevel, _setStudyLevel] = useAtom(studyLevelState);
  const [courseStream, setCourseStream] = useState([]);
  const [selectedStream, setSelectedStream] = useState();
  const [assignToMe, setAssignToMe] = useState(false);
  const [myTeamList, setMyTeamList] = useState([]);
  const [selectedMyTeam, setSelectedMyTeam] = useState([]);

  const showDrawer = (activeRowId) => {
    // setActiveRowId(activeRowId);
    window.open(`/student/${activeRowId}`, "_blank");
    // navigate(`/student/${activeRowId}`);
    // setOpen(true);
  };

  const updateURLWithFilters = (filters) => {
    const searchParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (key === "page" || key === "limit") return;
      if (value !== undefined && value !== null && value !== "") {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            searchParams.append(`filter[${key}]`, value.join(","));
          }
        } else {
          searchParams.append(`filter[${key}]`, value);
        }
      }
    });
    if (filters.page) searchParams.append("page", filters.page);
    if (filters.limit) searchParams.append("limit", filters.limit);

    const newSearch = searchParams.toString();
    if (location.search.substring(1) !== newSearch) {
      navigate(`${location.pathname}?${newSearch}`, { replace: true });
    }
  };

  const applyFiltersFromURL = () => {
    // console.log("-------------applyFiltersFromURL--------------");
    const searchParams = new URLSearchParams(location.search);
    // console.log("searchParams", searchParams);
    const filters = {};
    const multipleKeys = ["level_id", "stream_id", "requirements", "subscription_status", "status", "gender", "city"];
    multipleKeys.forEach((key) => {
      filters[key] = [];
    });

    for (let [key, value] of searchParams.entries()) {
      if (key.startsWith("filter[")) {
        const matches = key.match(/filter\[(.*?)\]/);
        if (matches) {
          const [, filterKey] = matches;
          const splitValues = value.split(",").map((v) => v.trim()).filter(Boolean);
          if (multipleKeys.includes(filterKey)) {
            filters[filterKey] = splitValues;
          } else {
            filters[filterKey] = Array.isArray(splitValues) && splitValues.length > 1 ? splitValues : value;
          }
        }
      } else {
        filters[key] = value;
      }
    }
    // console.log("filters", filters);
    filterForm.setFieldsValue(filters);

    if (filters.stream_id && filters.stream_id.length > 0) {
      setSelectedStream(filters.stream_id);
    } else {
      setSelectedStream([]);
    }

    if (filters.searchFieldType) {
      setSearchFieldType(filters.searchFieldType);
      setSearchText(filters.searchText);
      if (filters.searchFieldType === "address") {
        setGeoSearchData(filters.searchText);
      }
    }
    // Date Filter Logic
    let fromDate = "";
    let toDate = "";

    // Relative Date Handling
    if (dateRangeType === DATE_FILTER_TYPE["relative"] && presetRange && DATE_RANGE_MAP[presetRange]) {
      fromDate = DATE_RANGE_MAP[presetRange].fromDate;
      toDate = DATE_RANGE_MAP[presetRange].toDate;
    }
    // Absolute Date Handling
    else if (dateRangeType === DATE_FILTER_TYPE["absolute"] && dateRange.length === 2) {
      const [start, end] = dateRange;

      // Check if start date is valid
      if (start.isAfter(end) || start.isSame(end)) {
        logMessage("To and From cannot be same");
        return;
      }
      fromDate = getDateRange(start);
      toDate = getDateRange(end);
    }

    // Add fromDate and toDate to filters if they exist
    if (fromDate) {
      filters.fromDate = fromDate;
    }
    if (toDate) {
      filters.toDate = toDate;
    }
    filters.isCreatedAt = isCreatedAt; //   -------------  Added isCreatedAt to filters   --------------

    const filterCount = Object.entries(filters).filter(([key, value]) => {
      if (["isCreatedAt", "searchText", "searchFieldType", "page", "limit", "fromDate", "toDate"].includes(key)) {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== undefined && value !== null && value !== "";
    }).length;
    setFiltersCount(filterCount);

    const page = filters.page ? Number(filters.page) : Number(pagination.current);
    const limit = filters.limit ? Number(filters.limit) : Number(pagination.pageSize);

    if (Object.keys(filters).length > 0) {
      fetchFilteredData(filters, page, limit);
    } else {
      fetchData(page, limit);
    }
  };

  useEffect(() => {
    if (dateRangeType === "absolute" && dateRange.length === 0) return;
    applyFiltersFromURL();
    // console.log("location useeffect", location.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, dateRange, dateRangeType, presetRange, isCreatedAt]);

  useEffect(() => {
    // applyFiltersFromURL();
    fetchCourseCategoryMaster();
    fetchStudyLevelMaster();
    fetchMyTeamForFilter();
    // console.log(" my team list useeffect");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchCourseCategoryMaster() {
    try {
      const { data } = await axiosInstance.get("/v1/cre/master/course-category/all");
      if (data && data.length) {
        setCourseCategory(data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchMyTeamForFilter() {
    try {
      const { data } = await axiosInstance.get("/v1/cre/dealings/fetch-my-team");
      if (data && data.data.length) {
        console.log("myteam", data.data);
        setMyTeamList(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchStudyLevelMaster() {
    // try {
    // const { data } = await axiosInstance.get(
    //   "/v1/cre/master/study-level/all"
    // );
    //   if (data && data.length) {
    //     setStudyLevel(data);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  }

  async function fetchCourseStreamMaster(filterCourseCategoryId) {
    try {
      console.log("calling for:", filterCourseCategoryId);
      if (!filterCourseCategoryId) return;
      const { data } = await axiosInstance.get("/v1/cre/student/stream/courses/all", {
        params: {
          category_id: filterCourseCategoryId,
        },
      });
      if (data && data.length) {
        setCourseStream(data);
      }
      console.log("streammmmm", data);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchData = async (page, pageSize) => {
    setLoading(true);
    try {
      // console.log("  -----------------   Fetch Data ---------------");
      const response = await axiosInstance.get("/v1/cre/student", {
        params: {
          page: page,
          limit: pageSize,
          filter: JSON.stringify({ tution_type: "offline" }),
        },
      });
      if (response.data.is_success && response.data.data && response.data.data.Result) {
        setData(response.data.data.Result);
        setPagination((prev) => ({
          ...prev,
          current: Number(page),
          pageSize: Number(pageSize),
          total: response.data.data.total || 0,
          hasNextPage: response.data.data.hasNextPage ?? false,
        }));
      } else {
        setData([]);
        setPagination((prev) => ({
          ...prev,
          current: Number(page),
          pageSize: Number(pageSize),
          total: 0,
          hasNextPage: false,
        }));
      }
    } catch (error) {
      //console.error("Error fetching data:", error);
      setData([]);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize: pageSize,
        total: 0,
      }));
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredData = async (filter, page = 1, limit = 25) => {
    const filterWithTuition = {
      ...filter,
      tution_type: filter.tution_type && filter.tution_type.length > 0 ? filter.tution_type : ["offline", "home"],
    };
    setGlobalFilter(filter);
    setData([]);
    setLoading(true);
    //Todo: This is a temporary fix , it needed to be removed
    if (filterWithTuition.searchFieldType == "address" && Array.isArray(filterWithTuition.searchText)) {
      filterWithTuition.searchText = `${filterWithTuition.searchText[0] + "," + filterWithTuition.searchText[1]}`;
    }
    // console.log("------------------ Fetch Filtered Data ---------------");
    const params = new URLSearchParams();
    // Handle filter parameters
    Object.entries(filterWithTuition).forEach(([key, value]) => {
      if (["page", "limit", "isCreatedAt", "fromDate", "toDate"].includes(key)) return;
      if (value !== undefined && value !== null && value !== "") {
        if (key === "searchText" || key === "searchFieldType") {
          // Directly append these specific filters without array notation
          params.append(`filter[${key}]`, value);
        } else {
          if (!Array.isArray(value)) {
            // Convert single values into an array
            value = [value];
          }

          // Append each value in the array with the correct format
          value.forEach((val) => {
            params.append(`filter[${key}][]`, val);
          });
        }
      }
    });

    // Add pagination parameters
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    filter.isCreatedAt && params.append("isCreatedAt", filter.isCreatedAt); // ------- added the filter for isCreatedAt

    try {
      const response = await axiosInstance.get(`/v1/cre/student?${params?.toString()}`);
      if (response.data.is_success && response.data.data && response.data.data.Result) {
        setData(response.data.data.Result);
        setPagination((prev) => ({
          ...prev,
          current: Number(page),
          pageSize: Number(limit),
          total: response.data.data.total || 0,
          hasNextPage: response.data.data.hasNextPage ?? false,
        }));
      } else {
        setData([]);
        setPagination((prev) => ({
          ...prev,
          current: Number(page),
          pageSize: Number(limit),
          total: 0,
          hasNextPage: false,
        }));
      }
    } catch (error) {
      //console.error("Error fetching filtered data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (!globalFilter) {
      fetchData(pagination.current, pagination.pageSize);
    } else {
      fetchFilteredData(globalFilter, pagination.current, pagination.pageSize);
    }
  };

  const handleDateRangeTypeChange = (checked) => {
    setDateRangeType(checked ? DATE_FILTER_TYPE["absolute"] : DATE_FILTER_TYPE["relative"]);
    setDateRange([]);
    setPresetRange("");
  };
  const handleCreatedAtChange = (checked) => setIsCreatedAt(checked);
  const handleDateChange = (dates) => {
    if (dates) {
      setDateRange(dates);
      setPresetRange("");
    } else {
      setDateRange([]);
      setPresetRange("");
    }
  };

  const handlePresetRangeChange = (value) => {
    setPresetRange(value);
    setDateRange([]);
  };

  const logMessage = (value) => {
    messageApi.info(value);
  };

  const handleDownload = async () => {
    if (!limit) {
      notification.error({
        message: "Limit Required",
        description: "Please enter a limit value.",
      });
      return;
    }

    try {
      // Make API request to process bulk download
      const response = await axiosInstance.post("/v1/cre/download/", {
        limit,
        user_type: "Student",
      });

      if (response.data && response.data?.resp_code === 200) {
        notification.success({
          message: "Requested Download Data",
          description: "Requested Download Data Successfully",
        });
        setLimit(0);
      } else {
        notification.error({
          message: "Failed to Process",
          description: response.data.resp_message || "Unable to process bulk download.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while processing bulk download.",
      });
    }
  };

  const columns = [
    {
      title: "Deal ID",
      dataIndex: "id",
      key: "id",
      width: "70px",
      render: (_, record) => {
        return <>{record?.id}</>;
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: "150px",
      render: (_, record) => {
        let color = "white";
        if (record?.profile_status === "Block") {
          color = "red";
        }
        if (record?.profile_status === "InActive") {
          color = "cyan";
        }
        const date = record?.created_at ? dayjs.utc(record.created_at).tz(IST).format("DD MMM YYYY, hh:mm A") : "";

        return (
          <Tag
            color={color}
            style={{
              width: "100%",
            }}
          >
            <Flex
              style={{
                color: "#262121",
                margin: "0px auto",
                minHeight: "30px",
              }}
              justify="center"
              align="center"
            >
              {date}
            </Flex>
          </Tag>
        );
      },
      sorter: () => {
        return true;
      },
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      width: "150px",
      render: (_, record) => {
        let color = "white";
        if (record?.profile_status === "Block") {
          color = "red";
        }
        if (record?.profile_status === "InActive") {
          color = "cyan";
        }
        const date = record?.updated_at ? dayjs.utc(record.updated_at).tz(IST).format("DD MMM YYYY, hh:mm A") : "";

        return (
          <Tag
            color={color}
            style={{
              width: "100%",
            }}
          >
            <Flex
              style={{
                color: "#262121",
                margin: "0px auto",
                minHeight: "30px",
              }}
              justify="center"
              align="center"
            >
              {date}
            </Flex>
          </Tag>
        );
      },
      sorter: () => {
        return true;
      },
    },
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      width: "200px",
      ellipsis: true,

      render: (_, record) => {
        const name = record?.first_name + " " + record?.last_name;
        let color = "white";
        if (record?.profile_status === "Block") {
          color = "red";
        }
        if (record?.profile_status === "InActive") {
          color = "cyan";
        }

        return (
          <Tag
            color={color}
            style={{
              width: "100%",
            }}
          >
            <Flex
              align="center"
              style={{
                color: record?.is_paid ? "#59d559" : "#262121",
                fontWeight: record?.is_paid ? "bolder" : "",
                cursor: "pointer",
                textTransform: "capitalize",
                minHeight: "30px",
              }}
              onClick={() => showDrawer(record.id)}
            >
              <Tooltip title={name} placement="bottomLeft">
                <div style={{ minWidth: `${name?.length * 8}px` }}>
                  {name}
                  {record?.is_approved ? (
                    <img src="./approved-icon.svg" alt="tick mark" height="12px" style={{ marginLeft: "5px" }} />
                  ) : (
                    <></>
                  )}
                </div>
              </Tooltip>
            </Flex>
          </Tag>
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: "120px",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: "100px",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "100px",
      render: (_, record) => {
        let status = record?.status;
        if (status === "pending" && record?.advance_payment) {
          status = "Processing";
        }
        return (
          <div style={{ minWidth: `${status?.length * 8}px` }}>
            <Tag color={STUDENT_DEALINGS_STATUS_COLORS[status]}>{status}</Tag>
          </div>
        );
      },
    },
    {
      title: "Priority Level",
      dataIndex: "priority_level",
      key: "priority_level",
      width: "60px",
      render: (_, record) => {
        let priority_level = record?.priority_level;
        return (
          <div style={{ minWidth: `${priority_level?.length * 8}px` }}>
            <Tag color={STUDENT_DEALINGS_PRIORITY_LEVEL_COLORS[priority_level]}>{priority_level}</Tag>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "is_subscription_active",
      key: "is_subscription_active",
      width: 150,
      render: (_, record) => {
        if (record.is_subscription_expired) {
          return (
            <Tag color="orange" className="tail-mb-2 tail-py-2">
              Expired
            </Tag>
          );
        }
        const advance_payment = record.is_subscription_active ? "Subscribed" : "unsubscribed";
        return (
          <Tag color={advance_payment === "Subscribed" ? "success" : "error"} className="tail-mb-2 tail-py-2">
            {advance_payment}
          </Tag>
        );
      },
    },
    {
      title: "Requirements",
      dataIndex: "requirements",
      key: "requirements",
      width: "300px",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => {
        const requirements = record?.requirements
          ?.split("<-->")
          .map((area) => {
            if (area !== "undefined") return area;
            return "";
          })
          .join(" ");
        return (
          <Tooltip placement="topLeft" title={requirements}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {requirements}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Level",
      dataIndex: "level_name",
      key: "level_name",
      width: "100px",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: "100px",
      render: (_, record) => {
        const category = courseCategory.find((category) => category.category_id === record?.category_id)?.category_name;
        return category;
      },
    },
    {
      title: "Days/Week",
      dataIndex: "how_many_days_in_a_week",
      key: "how_many_days_in_a_week",
      width: "100px",
    },
    {
      title: "Tutor Gender Preference",
      dataIndex: "tutor_gender_preference",
      key: "tutor_gender_preference",
      width: "100px",
    },
    {
      title: "Tution Type",
      dataIndex: "tution_type",
      key: "tution_type",
      width: 100,
    },
    {
      title: "Assigned To",
      dataIndex: "admin_name",
      key: "admin_name",
      width: "150px",
    },
    {
      title: "City",
      dataIndex: "city_id",
      key: "city_id",
      width: "100px",
      render: (_, record) => {
        const cityName = citys[record.city_id];
        return (
          <div
            style={{
              width: `${cityName?.length * 10}px`,
            }}
          >
            {cityName}
          </div>
        );
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: 250,
      ellipsis: {
        showTitle: true,
      },
      render: (_, record) => {
        const address = record?.address
          ?.split("<-->")
          .map((area) => {
            if (area !== "undefined") return area;
            return "";
          })
          .join(" ");
        return (
          <Tooltip placement="topLeft" title={address}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {address}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Lead Type",
      dataIndex: "created_from",
      key: "created_from",
      width: "100px",
    },
    {
      title: "Reference Type",
      dataIndex: "reference",
      key: "reference",
      width: "100px",
    },
  ];

  return (
    <>
      {contextHolder}
      <Flex style={{ margin: "15px auto" }} align="center" justify="space-between" direction="row">
        <Flex align="center" style={{ width: "450px", justifyContent: "flex-start" }}>
          <div style={{ width: "120px", marginRight: "10px" }}>
            <Switch
              className="toggle"
              checkedChildren="Created At"
              unCheckedChildren="Updated At"
              checked={isCreatedAt}
              onChange={handleCreatedAtChange}
            />
            <Switch
              checkedChildren="Absolute"
              unCheckedChildren="Relative"
              checked={dateRangeType === "absolute"}
              onChange={handleDateRangeTypeChange}
            />
          </div>
          {dateRangeType === "absolute" ? (
            <RangePicker
              style={{ width: "300px" }}
              value={dateRange}
              onChange={handleDateChange}
              allowClear={false}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          ) : (
            <Select
              style={{ width: "300px" }}
              value={presetRange || undefined}
              placeholder="Select option to filter"
              onChange={handlePresetRangeChange}
            >
              <Option value="today">Today</Option>
              <Option value="yesterday">Yesterday</Option>
              <Option value="this_week">This Week</Option>
              <Option value="last_week">Last Week</Option>
              <Option value="this_month">This Month</Option>
              <Option value="last_month">Last Month</Option>
            </Select>
          )}
        </Flex>

        <Row align="middle">
          <Col style={{ margin: "auto 10px" }}>
            <Select
              placeholder="Select Type"
              style={{ width: 120, fontWeight: "bolder" }}
              value={searchFieldType}
              onChange={(e) => {
                setSearchFieldType(e);
                setSearchText(null);
              }}
              defaultValue={"name"}
            >
              <Option value="first_name">Name</Option>
              <Option value="phone">Phone</Option>
              <Option value="address">Address</Option>
              <Option value="userId">User Id</Option>
            </Select>
          </Col>

          {searchFieldType === "address" ? (
            <Flex style={{ margin: "auto 10px" }}>
              <Autocomplete
                apiKey={apiKey}
                style={{ width: "500px", paddingRight: "30px" }}
                className="ant-input css-dev-only-do-not-override-1uweeqc ant-input-outlined"
                onPlaceSelected={(place) => {
                  setSearchText(place.formatted_address);
                  let latitude = place.geometry.location.lat();
                  let longitude = place.geometry.location.lng();
                  setGeoSearchData(latitude + "," + longitude);
                }}
                options={{
                  types: [],
                  componentRestrictions: { country: "IN" },
                }}
                onChange={(e) => {
                  // reset page size and current page to 1
                  setPagination({
                    ...pagination,
                    current: 1,
                    pageSize: 25,
                  });
                  setSearchText(e.target.value);
                }}
                value={searchText}
              />

              <SearchOutlined
                style={{
                  cursor: "pointer",
                  marginLeft: "-29px",
                  padding: "5px",
                  zIndex: 1,
                  color: "rgba(0, 0, 0, 0.5)",
                  borderLeft: "1px solid #d9d9d9",
                }}
                onClick={() => {
                  if (searchText) {
                    updateURLWithFilters({
                      ...(globalFilter ? globalFilter : {}),
                      searchText: geoSearchData,
                      searchFieldType,
                      page: 1,
                      limit: pagination.pageSize,
                    });
                  }
                }}
              />
            </Flex>
          ) : (
            <Search
              value={searchText}
              type={searchFieldType === "phone" ? "number" : "text"}
              maxLength={searchFieldType === "phone" ? 10 : undefined}
              style={{ width: 500 }}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              placeholder={searchFieldType === "phone" ? "Phone" : "Search"}
              onSearch={() => {
                updateURLWithFilters({
                  ...(globalFilter ? globalFilter : {}),
                  searchText,
                  searchFieldType,
                  page: 1,
                  limit: pagination.pageSize,
                });
              }}
            />
          )}
        </Row>

        {searchFieldType !== "userId" && (
          <Col style={{ margin: "auto 10px", position: "relative" }}>
            <Badge
              count={filtersCount}
              style={{
                position: "absolute",
                top: "0px",
                cursor: "pointer",
                right: "8px",
                backgroundColor: "rgba(39, 65, 120, 1)",
              }}
              onClick={() => {
                setFilterDrawerOpen(true);
              }}
              overflowCount={99}
            >
              <FilterOutlined style={{ cursor: "pointer", margin: "auto 12px" }} />
            </Badge>
          </Col>
        )}

        <Col>
          <Button
            type="primary"
            style={{
              margin: "10px",
              color: "white",
              backgroundColor: "rgba(39, 65, 120, 1)",
            }}
            onClick={() => {
              setSearchText(null);
              setSearchFieldType("first_name");
              setGeoSearchData(null);
              setGlobalFilter(null);
              setFiltersCount(0);
              filterForm.resetFields();
              setDateRangeType("relative");
              setDateRange([]);
              setPresetRange("");
              setSelectedStream("");
              setSelectedMyTeam([]);
              setAssignToMe(false);
              setPagination((prev) => ({
                ...prev,
                current: 1,
                pageSize: 25,
              }));
              navigate(location.pathname, { replace: true }); // Clear URL parameters
            }}
          >
            Clear Filters
          </Button>
        </Col>
      </Flex>

      <Flex justify="flex-end">
        <Button
          color="primary"
          variant={assignToMe ? "solid" : "outlined"}
          className="tail-m-3"
          onClick={() => {
            const newAssignToMe = !assignToMe;
            setAssignToMe(newAssignToMe);
            updateURLWithFilters({
              ...(globalFilter ? globalFilter : {}),
              is_assigned_to_cre: newAssignToMe,
              page: 1,
            });
          }}
        >
          {assignToMe ? "Assigned" : "Assign to me"}
        </Button>

        <Select
          value={selectedMyTeam}
          mode="multiple"
          placeholder="Assign to team"
          style={{ width: 200 }}
          className="tail-m-3"
          onChange={(value) => {
            console.log("newSelectedMyTeam", value);
            setSelectedMyTeam(value);
            updateURLWithFilters({
              ...(globalFilter ? globalFilter : {}),
              my_team_assignment: value,
              page: 1,
            });
          }}
        >
          {myTeamList.map((team) => (
            <Option key={String(team.admin_id)} value={String(team.admin_id)}>
              {team.admin_name}
            </Option>
          ))}
        </Select>
      </Flex>

      {role === USER_ROLES.SUPERADMIN && (
        <Flex justify="flex-end">
          <Row>
            <Col>
              <InputNumber
                min={1}
                max={24}
                placeholder="Enter Limit"
                value={limit}
                onChange={(value) => setLimit(value)} // No need to access `e.value`, just use `value`
                style={{ margin: "10px", width: "150px" }}
              />
              <Typography.Text>Limit (in Months)</Typography.Text>
            </Col>
            <Col>
              <Button
                type="primary"
                style={{
                  margin: "10px",
                  color: "white",
                  backgroundColor: "rgba(39, 65, 120, 1)",
                }}
                onClick={handleDownload}
              >
                Download
              </Button>
            </Col>
          </Row>
        </Flex>
      )}

      <Flex
        style={{
          overflow: "scroll",
          marginLeft: "5px",
        }}
      >
        <div style={{ width: "100%" }}>
          <Table columns={columns} dataSource={data} pagination={false} loading={loading} />

          {/* Custom Pagination */}
          <Flex
            justify="space-between"
            align="center"
            style={{
              marginTop: "16px",
              padding: "8px 0",
            }}
          >
            <Flex align="center" gap="middle">
              <span style={{ color: "rgba(0, 0, 0, 0.85)", marginRight: "8px" }}>Page Size:</span>
              <Select
                value={pagination.pageSize}
                onChange={(value) => {
                  const pageSize = Number(value);
                  updateURLWithFilters({
                    ...(globalFilter ? globalFilter : {}),
                    page: 1,
                    limit: pageSize,
                  });
                }}
                style={{ width: 100 }}
              >
                <Option value={10}>10</Option>
                <Option value={15}>15</Option>
                <Option value={20}>20</Option>
                <Option value={25}>25</Option>
                <Option value={50}>50</Option>
                <Option value={100}>100</Option>
                <Option value={150}>150</Option>
                <Option value={200}>200</Option>
                <Option value={250}>250</Option>
                <Option value={500}>500</Option>
              </Select>
            </Flex>

            <Flex align="center" gap="middle">
              <Button
                disabled={Number(pagination.current) === 1}
                onClick={() => {
                  const currentPage = Number(pagination.current);
                  const newPage = currentPage - 1;
                  updateURLWithFilters({
                    ...(globalFilter ? globalFilter : {}),
                    page: newPage,
                    limit: pagination.pageSize,
                  });
                }}
              >
                Previous
              </Button>

              <span
                style={{
                  padding: "0 12px",
                  display: "inline-block",
                  minWidth: "40px",
                  height: "32px",
                  lineHeight: "32px",
                  textAlign: "center",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  margin: "0 8px",
                  fontWeight: "500",
                  backgroundColor: "#fafafa",
                }}
              >
                {Number(pagination.current)}
              </span>

              <Button
                disabled={!data || !pagination.hasNextPage}
                onClick={() => {
                  const currentPage = Number(pagination.current);
                  const newPage = currentPage + 1;
                  updateURLWithFilters({
                    ...(globalFilter ? globalFilter : {}),
                    page: newPage,
                    limit: pagination.pageSize,
                  });
                }}
              >
                Next
              </Button>
            </Flex>
          </Flex>
        </div>
      </Flex>

      {/* -------------------- This Student Drawer component is unreachable ---------------- */}
      {/* {open && (
        <StudentDrawer
          id={activeRowId}
          open={open}
          setOpen={setOpen}
          dataHandle={dataHandle}
          setDataHandle={setDataHandle}
        />
      )} */}

      <Drawer
        open={filterDrawerOpen}
        title="Filter"
        placement="right"
        closable
        onClose={() => setFilterDrawerOpen(false)}
        style={{ border: " 4ps solid red" }}
        width={400}
      // width={window.innerWidth < 768 ? "80%" : 400}
      >
        <Form
          layout="vertical"
          form={filterForm}
          style={{ padding: "0px" }}
          onFinish={(e) => {
            const { current, pageSize } = pagination;
            const dateFilter =
              dateRangeType === "absolute"
                ? {
                  fromDate: dateRange[0]?.format("YYYY-MM-DD"),
                  toDate: dateRange[1]?.format("YYYY-MM-DD"),
                }
                : dateRangeMap[presetRange];

            updateURLWithFilters({
              ...e,
              ...dateFilter,
              searchFieldType,
              searchText: searchFieldType === "address" ? geoSearchData : searchText,
              page: 1,
              limit: pageSize,
            });
            setFilterDrawerOpen(false);
          }}
        >
          <Form.Item label="Course Category" name="category_id">
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Select"
              // options={courseCategory?.map((category) => ({
              //   key: category.category_id,
              //   label: category.category_name,
              //   value: category.category_id,
              // }))}
              onChange={(value) => {
                console.log("course category id", value);
                fetchCourseStreamMaster(value);
                setSelectedStream("");
              }}
            >
              {courseCategory?.map((category) => (
                <Option key={String(category.category_id)} value={String(category.category_id)}>
                  {category.category_name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Study Level" name="level_id">
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Level"
            // options={studyLevel.map((level) => ({
            //   value: level.id,
            //   label: level.name,
            // }))}
            >
              {studyLevel.map((level) => (
                <Option key={String(level.id)} value={String(level.id)}>
                  {level.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Course Stream" name="stream_id">
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              allowClear
              placeholder="Select Stream"
              // defaultValue={selectedStream}
              // options={courseStream.map((stream) => ({
              //   key: stream.stream_id,
              //   value: stream.stream_id,
              //   label: stream.stream_name,
              // }))}
              onChange={(value) => {
                setSelectedStream(value);
              }}
            >
              {courseStream.map((stream) => (
                <Option key={String(stream.stream_id)} value={String(stream.stream_id)}>
                  {stream.stream_name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Course" name="requirements">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Course">
              {Array.from(
                new Set(
                  courseStream
                    .filter((stream) => {
                      if (Array.isArray(selectedStream)) {
                        return selectedStream.map(String).includes(String(stream.stream_id));
                      }
                      return String(stream.stream_id) === String(selectedStream);
                    })
                    .flatMap((stream) => stream.courses || [])
                )
              ).map((course) => (
                <Option key={course} value={course}>
                  {course}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Type" name="subscription_status">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Subscription Status">
              <Option value="Subscribed">Subscribed</Option>
              <Option value="Unsubscribed">Unsubscribed</Option>
              <Option value="Expired">Expired</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Status">
              <Option value="PENDING">Pending</Option>
              <Option value="DEMO">Demo</Option>
              <Option value="ASSIGNED">Assigned</Option>
              <Option value="CONFIRMED">Confirmed</Option>
              <Option value="NEW">New</Option>
              <Option value="WAITING_RESPONSE">Waiting Response</Option>
              <Option value="CALL_NOT_RECEIVED">Call Not Received</Option>
              <Option value="IN_PROGRESS">In Progress</Option>
              <Option value="ESCALATE">Escalate</Option>
              <Option value="INACTIVE">Inactive</Option>
              <Option value="PROSPECT">Prospect</Option>
              <Option value="NOT_INTERESTED">Not Interested</Option>
              <Option value="REPLACED">Replaced</Option>
              <Option value="ACTIVE">Active</Option>
              <Option value="CANCELLED">Cancelled</Option>
              <Option value="PAYMENT_PENDING">Payment Pending</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Priority Level" name="priority_level">
            <Select style={{ width: "100%" }} placeholder="Select Priority Level">
              <Option value="P1">P1</Option>
              <Option value="P2">P2</Option>
              <Option value="P3">P3</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Tutor Gender" name="gender">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Gender">
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
            </Select>
          </Form.Item>

          <Form.Item label="City" name="city">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select City">
              {role !== "Superadmin"
                ? studentCityAccess?.map((city_id) => (
                  <Option key={city_id} value={city_id}>
                    {citys?.[city_id]}
                  </Option>
                ))
                : Object.keys(citys).map((city_id) => (
                  <Option key={city_id} value={city_id}>
                    {citys?.[city_id]}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item label="Lead Type" name="created_from">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Status">
              <Option value="WEB_FORM">WebForm</Option>
              <Option value="CALL">Call</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Reference" name="reference">
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Select Reference">
              <Option value="Instagram">Instagram</Option>
              <Option value="Linkedin">Linkedin</Option>
              <Option value="Youtube">Youtube</Option>
              <Option value="Reference">Reference</Option>
              <Option value="Google">Google</Option>
              <Option value="Facebook">Facebook</Option>
            </Select>
          </Form.Item>

          {/* <Form.Item label="Assign to" name="is_assigned_to">
            <Select style={{ width: "100%" }} placeholder="Assign to">
              <Option value="ASSIGN_TO_CRE">Assign to me</Option>
              <Option value="ASSIGN_TO_TEAM">Assign to my team</Option>
            </Select>
          </Form.Item> */}

          <Space style={{ margin: "10px" }}>
            <Button type="primary" htmlType="submit" style={{ marginRight: "5px" }}>
              Submit
            </Button>
            <Button
              type="default"
              onClick={() => {
                filterForm.resetFields();
                setFilterDrawerOpen(false);
              }}
            >
              Cancel
            </Button>
          </Space>
        </Form>
      </Drawer>
    </>
  );
};

export default Student;
